import axios from "@/axios";

const state = {
  loading: false,
  storeOneId:undefined,
  edit:[]
};

const actions = {
  async ok({commit}, payload) {
    try{
      commit('LOADING', true);
      await axios.put('admin/store/'+payload.id,{data:payload,op:'sts'})
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING', false);
    }
  },

  async save({commit}, payload) {
    try{
      commit('LOADING', true);
      await axios.post('admin/store',{data:payload})
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING', false);
    }
  },

  async get({commit},id) {
    try {
      commit('LOADING', true);
      let res = await axios.get('admin/store/'+id);
      console.log(res.data,'res data')
      commit('STORE_ID', res.data);
    } catch (e) {
      console.log(e)
      throw e;
    } finally {
      commit('LOADING', false);
    }
  },

  async put({commit}, payload) {
    try{
      commit('LOADING', true);
      await axios.put('admin/store/'+payload.id, {id:payload.id,data:payload.data,op:'update'})
      commit('UPDATE_STORE', payload);
    }catch (e) {
      commit('ERROR', e);
    } finally {
      commit('LOADING', false);
    }
  },

  async submitDateLine({commit}, payload) {
    try{
      commit('LOADING', true);
      const save = await axios.post('admin/store/chart/date',payload)
      return save
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING', false);
    }
  },
  async submitGrowthStore({commit}, payload) {
    try{
      commit('LOADING', true);
      const growth = await axios.post('admin/store/chart/create',payload)
      return growth
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING', false);
    }
  },

};

const mutations = {
  LOADING(state, payload) {
    state.loading = payload;
  },
  STORE_ID(state,payload){
    state.storeOneId = payload
  },
  UPDATE_STORE(state, payload) {
    state.edit = state.edit.map(edit => {
      if (edit.id === payload.id) {
        return Object.assign({},edit, payload.data)
      }
      return edit
    })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
